import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { IMask, IMaskInput } from "react-imask";

/**
 * RangedTimeMaskedInputBase
 */
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const RangedTimeMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={false}
    />
  );
});


/**
 * FormRangedTimeMaskedInput
 */

type Props<T extends {}> = {
  name: keyof T,
  label: string,
  required?: boolean,
  reactHookForm: UseFormReturn<T>,
};

export const FormRangedTimeMaskedInput = <T extends {},>({
  name,
  label,
  required,
  reactHookForm,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText: string | null = null;

        if (name in formState.errors) {
          const error = formState.errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <FormControl variant="outlined" size="small">
            <InputLabel
              htmlFor={`input-${name as string}`}
              error={helperText !== null}
              required={required}
              shrink={true}
              size="small">
              {label}
            </InputLabel>

            <OutlinedInput
              size="small"
              id={`input-${name as string}`}
              name={name as string}
              value={field.value}
              label={label}
              notched={true}
              required={required}
              onChange={field.onChange}
              disabled={formState.disabled}
              error={helperText !== null}
              aria-describedby={`${name as string}-component-error-text`}
              inputComponent={RangedTimeMaskedInputBase as any}
              inputProps={{
                mask: 'HH:MM - HH:MM',
                blocks: {
                  HH: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 23,
                    maxLength: 2,
                    placeholder: '__',
                  },
                  MM: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                    maxLength: 2,
                    placeholder: '__',
                  },
                },
              }} />

            <FormHelperText id={`${name as string}-component-error-text`} error={true}>
              {helperText}
            </FormHelperText>
          </FormControl>
        );
      }} />
  );
}